import { render, staticRenderFns } from "./selected-coach-feedback.vue?vue&type=template&id=b09871da&scoped=true"
import script from "./selected-coach-feedback.vue?vue&type=script&lang=js"
export * from "./selected-coach-feedback.vue?vue&type=script&lang=js"
import style0 from "./selected-coach-feedback.vue?vue&type=style&index=0&id=b09871da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09871da",
  null
  
)

export default component.exports